import PiicHero from "./components/PiicHero";
import PiicWhatIs from "./components/PiicWhatIs";
import PiicProcess from "./components/PiicProcess";
import PiicCells from "./components/PiicCells";
import PiicPathwayNav from "./components/PiicPathwayNav";
import PiicOutcomes from "./components/PiicOutcomes";

export default function Piic() {
  return (
    <main className="min-h-screen">
      <PiicHero />
      <PiicWhatIs />
      <PiicProcess />
      <PiicCells />
      <PiicPathwayNav />
      <PiicOutcomes />
    </main>
  );
}